import axiosInstance from "@/api/axiosInstance";
import { ResendPaymentRequestResponse } from "./types";

export async function resendPaymentRequest(
  uuid: string,
): Promise<ResendPaymentRequestResponse> {
  const response = await axiosInstance.post(
    `/api/private/payment-requests/${uuid}/resend`,
  );
  return response.data?.data ?? response.data;
}
